import i18n from 'i18n/i18n';
import moment from 'moment';
import {CustomerDto} from '../../../../PRMGApiClient/models/CustomerDto';

export const DATE_TIME_FORMAT = 'DD.MM.YYYY | HH:mm';
export const DATE_FORMAT = 'DD.MM.YYYY';
export const TIME_FORMAT = 'HH:mm';

export function dateHoursFormat(d: Date | undefined): string | undefined {
  if (!d) {
    return;
  }
  const hours = d.getHours();
  const minutes = d.getMinutes();
  return (hours === 0 && minutes === 0) || (hours === 23 && minutes === 59)
    ? dateFormat(d)
    : moment(d).format(DATE_TIME_FORMAT);
}

export function dateFormat(d: Date | undefined): string | undefined {
  return d !== undefined ? moment(d).format(DATE_FORMAT) : undefined;
}

export function timeFormat(d: Date | undefined): string | undefined {
  return d !== undefined ? moment(d).format(TIME_FORMAT) : undefined;
}

export function dateFormatToString(d: Date | undefined): string {
  return d !== undefined ? moment(d).format(DATE_FORMAT).toString() : '';
}

export function customerDisplayName(c?: CustomerDto): string {
  if (!c) {
    return '';
  }

  return c.isCompany ? c.companyName ?? '' : c.firstName + ' ' + c.lastName;
}

export function IntlDAteFormat(d: Date | undefined): string {
  return d !== undefined
    ? new Intl.DateTimeFormat(i18n.isInitialized ? i18n.language : 'en', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).format(d)
    : '';
}
